import { Divider, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import { numberToCurrency } from '../../utils/objectUtils'
import { CloseOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons'
import { closePulltabDeck, updatePulltabDecks } from '../../services/pulltabDecks'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import Button from '../../components/UI/Button'
import { getPulltabGameFlare } from '../../services/pulltabGames'
import { useAuth } from '../../context/AuthProvider/useAuth'
import { onlyLetters, onlyNumbers } from '../../utils/formValidation'
import ItemGame from './ItemGame'
import { serverUrl } from '../../services/api'
import { transformToNumberAndCompare } from '../../utils/sorters'


export interface iLocation {
  id: number,
  name: string,
  closeAtBusinessDayEnd: boolean,
  closeAtMonthEnd: boolean,
  currentDate: string,
  status: string
}

export interface iListGames {
  id: any
  title: string
  image: string
  listItemsGame: iItemGameList[]
  gameAvailable: boolean
  gameAvailableStart: string
  gameAvailableEnd: string

}

export interface iItemGameList {
  id: number
  wager: string
  avaliable: boolean
  autoCreate: boolean
  autoClose: boolean
  gameAutoCreate: boolean
  gameAutoClose: boolean
  form: string
  tickets: number
  gameGroup: null,
  pivotForm: null,
  variant: string
  serial: string
  remaining: string
  isClosing: boolean
  gameAvailableStartSetting: boolean;
  gameAvailableStart: string;
  gameAvailableEndSetting: boolean;
  gameAvailableEnd: String;
  gameAvailable: boolean;

}

interface locationPayloadRequest {
  id: number,
  closeAtBusinessDayEnd: boolean,
  closeAtMonthEnd: boolean
}

interface changesPayloadRequest {
  id: number,
  avaliable: boolean,
  autoCreate: boolean,
  autoClose: boolean
}

interface payloadRequest {
  location: locationPayloadRequest
  changes: changesPayloadRequest[]
}

function RawHtml(props: { location: iLocation, listGames: iListGames[], onSave: () => void }) {
  const { location, listGames } = props;
  const loading = useLoading()
  const [body, setBody] = useState<string[]>([])
  let { canEdit } = useAuth()
  const [refresh, setRefresh] = useState(0)
  const [gameGroups, setGameGroups] = useState(new Map())
  var noPlayWarning = false
  if(location?.status === 'CLOSED') {
    canEdit = false
  }

  const floatingButtonnStyle = {
    none: 'none',
    flex: 'flex',
    translateAtView: canEdit ? 'translate(-137px, 0px)' : 'translate(1000px, 0px)',
    translateOutView: 'translate(1000px, 0px)'
  }

  const handleCheckBox = (id: string, value?: boolean | undefined) => {
    const element: any = document.getElementById(id)
    if (!element) return
    element.checked = value === undefined ? !element.checked : value
  }

  const handleControls = (field: string, value: boolean) => {
    const elements = document.querySelectorAll(`[data-${field}="true"]`)
    if (elements) {
      elements.forEach((element: any) => {
        if(!element.disabled) element.checked = value
      })
    }
    checkBody()
    setRefresh( state => state + 1)
  }

  const handleWager = (field: string, value: boolean) => {
    const elements = document.querySelectorAll(`[data-wager="${field}"]`)
    if (elements) {
      elements.forEach((element: any) => {
        if(!element.disabled) element.checked = value
      })
    }
    checkBody()
    setRefresh( state => state + 1)
  }

  const populateFields = (checkFields?: boolean | number) => {
    //console.log("Populate Fields")
    handleCheckBox('end_of_business_day', location.closeAtBusinessDayEnd)
    handleCheckBox('end_of_business_month', location.closeAtMonthEnd)
    const gameGroupMap = new Map<string, {available: boolean, autoload: boolean, autoclose: boolean, mismatch:boolean}>
    listGames.map((game) => {

      game.listItemsGame.map((item) => {
          if (item.gameGroup) {
            //console.log(`Group: ${item.gameGroup}`)
            //console.log(`gameGroupMapReallyInside: ${JSON.stringify(gameGroupMap)}`)
            if (gameGroupMap.get(item.gameGroup)) {
              //console.log(`Found ${JSON.stringify(gameGroupMap.get(item.gameGroup))}`)
              const gameGroup = gameGroupMap.get(item.gameGroup)
              // @ts-ignore
              if (gameGroup.available !== item.gameAvailable || gameGroup.autoclose !== item.gameAutoClose || gameGroup.autoload!= item.gameAutoCreate){
                // @ts-ignore
                gameGroup.mismatch = true
              }
            } else {
              //console.log(`Adding gameGroup ${item.gameGroup}`)
              const gameGroup = {available: item.gameAvailable, autoload: item.gameAutoCreate, autoclose: item.gameAutoClose, mismatch: false}
              gameGroupMap.set(item.gameGroup, gameGroup)
            }
          }
          item.avaliable ? handleCheckBox(`auto-close_${item.id}`, item.autoClose) : handleCheckBox(`auto-close_${item.id}`, item.gameAutoClose)
          handleCheckBox(`avaliable_${item.id}`, item.avaliable)
          item.avaliable ? handleCheckBox(`auto-create_${item.id}`, item.autoCreate) : handleCheckBox(`auto-create_${item.id}`, item.gameAutoCreate)
      })
      validateTableHeaderCheckbox(game.id)
      //console.log(`gameGroupMapInside: ${JSON.stringify(gameGroupMap)}`)
    })
    //console.log(`gameGroupMap: ${JSON.stringify(gameGroupMap)}`)
    //console.log(`gameGroup20000: ${JSON.stringify(gameGroupMap.get("20000"))}`)
    setGameGroups(gameGroupMap)
    if (checkFields) checkBody()
    if (checkFields === 2) {
      const floatingButtonConfirm = document.getElementById('floating-button-confirm')
      if (floatingButtonConfirm) floatingButtonConfirm.style.display = floatingButtonnStyle.none
      const floatingButtonCancel = document.getElementById('floating-button-cancel')
      if (floatingButtonCancel) floatingButtonCancel.style.transform = floatingButtonnStyle.translateOutView
    }
  }

  useEffect(() => {
    populateFields()
    const inputElements: NodeListOf<HTMLInputElement> = document.querySelectorAll("input[type=checkbox]")
    if (inputElements) {
      const bodyInputs: string[] = []
      inputElements.forEach((element: HTMLInputElement) => {
        bodyInputs.push(`${element.checked}`)
      })
      setBody(bodyInputs)
    }
  }, [location])

  useEffect(() => {
    //console.log(JSON.stringify(gameGroups.get("20000")))
  }, [gameGroups])

  const validateTableHeaderCheckbox = (id: string) => {
    const fields = ['avaliable', 'create', 'close']
    fields.forEach((field) => {
      const checkboxes: any = document.querySelectorAll(`[data-${field}-id="${id}"]`)
      const headerCheckbox: any | null = document.getElementById(`check-${field}_${id}`)
      if (checkboxes.length > 0) {
        let allChecked = true
        checkboxes.forEach((element: any) => {
          if (!element.checked) allChecked = false
        })
        headerCheckbox.checked = allChecked
      }
    })
  }

  const checkBody = (tableId?: string, itemGame?: iItemGameList) => {
    const inputElements: NodeListOf<HTMLInputElement> = document.querySelectorAll("input[type=checkbox]")
    let inputValues: typeof body = []
    if (inputElements) {
      inputElements.forEach((element) => {
        inputValues.push(`${element.checked}`)
      })
    }
    if (tableId) validateTableHeaderCheckbox(tableId)

    //set autoclose and autocreate to the system default
    const avaliableInput: any | null = document.getElementById(`avaliable_${itemGame?.id}`)
    if(avaliableInput && avaliableInput.checked && itemGame?.id) {
      const autoCloseInput: any | null = document.getElementById(`auto-close_${itemGame.id}`)
      const autoCreateInput: any | null = document.getElementById(`auto-create_${itemGame.id}`)
      if(autoCloseInput) autoCloseInput.checked = itemGame.gameAutoClose
      if(autoCreateInput) autoCreateInput.checked = itemGame.gameAutoCreate
    }

    const isChanged = body.join() !== inputValues.join()
    const floatingButtonConfirm = document.getElementById('floating-button-confirm')
    if (floatingButtonConfirm) floatingButtonConfirm.style.display = isChanged ? floatingButtonnStyle.flex : floatingButtonnStyle.none
    const floatingButtonCancel = document.getElementById('floating-button-cancel')
    if (floatingButtonCancel) floatingButtonCancel.style.transform = isChanged ? floatingButtonnStyle.translateAtView : floatingButtonnStyle.translateOutView
  }

  const showNoPlayWarning = () => {
    const inputElements: NodeListOf<HTMLInputElement> = document.querySelectorAll("input[type=checkbox]")
    if (inputElements) {
      inputElements.forEach((element) => {
        if((element.id === 'end_of_business_day' || element.id === 'end_of_business_month') && element.checked && !noPlayWarning) {
          noPlayWarning = true
          Modal.warning({
            title: 'Warning',
            content: 'Any decks that do not have any play will not be closed'
          });
        }
      })
    }
  }

  const confirmAutoCloseEnabled = (payload: payloadRequest, autoCloseEnabledList: string[]) => {
    Modal.confirm({
      title: 'Auto Close warning',
      content: 'Auto Close has been turned on for forms that already have decks.  This will not go into effect for any open decks.  You must close the decks for Auto Close to take effect immediately.  Or leave the decks open for Auto Close to take effect on deck completion. Auto Close enabled for: ' + autoCloseEnabledList.join(','),
      onOk: () => {completeOnSubmit(payload);},
      cancelText: 'Close',
    });
  }

  const completeOnSubmit = async (payload?: payloadRequest) => {
    loading.addLoading()
    await updatePulltabDecks(payload)
    new Promise(res => setTimeout(res => props.onSave(), 1000));
    const floatingButtonConfirm = document.getElementById('floating-button-confirm')
    if (floatingButtonConfirm) floatingButtonConfirm.style.display = floatingButtonnStyle.none
    const floatingButtonCancel = document.getElementById('floating-button-cancel')
    if (floatingButtonCancel) floatingButtonCancel.style.transform = floatingButtonnStyle.translateOutView
    loading.removeLoading()
  }

  const onSubmit = async () => {
    const closeAtBusinessDayEnd: any | null = document.getElementById('end_of_business_day')
    const closeAtMonthEnd: any | null = document.getElementById('end_of_business_month')
    let locationPayload: locationPayloadRequest = {
      id: location.id,
      closeAtMonthEnd: location.closeAtMonthEnd,
      closeAtBusinessDayEnd: location.closeAtBusinessDayEnd
    }
    if (closeAtBusinessDayEnd && closeAtMonthEnd) {
      locationPayload.closeAtBusinessDayEnd = closeAtBusinessDayEnd.checked
      locationPayload.closeAtMonthEnd = closeAtMonthEnd.checked
    }
    let changes: changesPayloadRequest[] | never = []

    let autoCloseEnabledList: string[] = []
    let availableMissingAutoClose: string[] = []
    let availableMissingAutoCreate: string[] = []
    const autoCloseCheckBoxes = new Map<string,any>()
    listGames.map((game) => {
      game.listItemsGame.map((item) => {
        let changed = false;
        let change: changesPayloadRequest = {
          id: item.id,
          avaliable: item.avaliable,
          autoCreate: item.autoCreate,
          autoClose: item.autoClose,
        }
        let secondaryGameGroupItem = false
        let autoCloseInput: any | null = document.getElementById(`auto-close_${item.id}`)
        const avaliableInput: any | null = document.getElementById(`avaliable_${item.id}`)
        const autoCreateInput: any | null = document.getElementById(`auto-create_${item.id}`)
        if (item.gameGroup)
          if (autoCloseInput == null) {
            autoCloseInput = autoCloseCheckBoxes.get(item.gameGroup)
            secondaryGameGroupItem = true
          } else  {
            autoCloseCheckBoxes.set(item.gameGroup, autoCloseInput)

          }

        //console.log(`Serial: ${item.serial} item.id: ${item.id} autoCloseInput: ${autoCloseInput} autoCloseInput.checked: ${autoCloseInput.checked} item.autoClose: ${item.autoClose}`)
        if (autoCloseInput && autoCloseInput.checked !== item.autoClose) {
          changed = true
          change.autoClose = autoCloseInput.checked
          if(!autoCloseInput.disabled && autoCloseInput.checked && item.serial.trim()!=="") {
            //console.log(`Adding serial: (${item.serial}) ${item.serial.length}`)
            autoCloseEnabledList.push(item.serial)
          }
        }
        if (avaliableInput && avaliableInput.checked !== item.avaliable) {
          changed = true
          change.avaliable = avaliableInput.checked
          if(avaliableInput.checked) {
            if(!autoCloseInput.disabled && !autoCloseInput.checked) {
              availableMissingAutoClose.push(item.serial)
            } else if (!autoCreateInput.disabled && !autoCreateInput.checked) {
              availableMissingAutoCreate.push(item.serial)
            }
          } 
        }
        if (autoCreateInput && autoCreateInput.checked !== item.autoCreate) {
          changed = true
          change.autoCreate = autoCreateInput.checked
        }

        if (changed && !secondaryGameGroupItem) {
          //console.log(`Change ${JSON.stringify(change)}`)
          changes.push(change)
        }

        if(item.gameGroup && changed && !secondaryGameGroupItem) {
          game.listItemsGame.forEach((o) => {
            if(item.gameGroup === o.gameGroup && item.id !== o.id) {
              //console.log(`Change item.id ${o.id}`)
              changes.push({
                id: o.id,
                avaliable: change.avaliable,
                autoCreate: change.autoCreate,
                autoClose: change.autoClose,
              })
            }
          })
        }

      })
    })

    const payload: payloadRequest = {
      location: locationPayload,
      changes
    }

    if (availableMissingAutoClose.length > 0 && availableMissingAutoCreate.length > 0) {
      Modal.confirm({
        title: 'Auto Close / Auto Create warning',
        content: 'You are about to create one or more decks with Auto Close and Auto Create turned off.  Do you want to proceed?',
        onOk: () => {if(autoCloseEnabledList.length > 0) {confirmAutoCloseEnabled(payload, autoCloseEnabledList)} else {completeOnSubmit(payload)}},
        cancelText: 'Close',
      });
    } else if (availableMissingAutoClose.length > 0) {
      Modal.confirm({
        title: 'Auto Close warning',
        content: 'You are about to create one or more decks with Auto Close turned off.  Do you want to proceed?',
        onOk: () => {if(autoCloseEnabledList.length > 0) {confirmAutoCloseEnabled(payload, autoCloseEnabledList)} else {completeOnSubmit(payload)}},
        cancelText: 'Close',
      });
    } else if (availableMissingAutoCreate.length > 0) {
      Modal.confirm({
        title: 'Auto Create warning',
        content: 'You are about to create one or more decks with Auto Create turned off.  Do you want to proceed?',
        onOk: () => {if(autoCloseEnabledList.length > 0) {confirmAutoCloseEnabled(payload, autoCloseEnabledList)} else {completeOnSubmit(payload)}},
        cancelText: 'Close',
      });
    } else if(autoCloseEnabledList.length > 0) {
      confirmAutoCloseEnabled(payload, autoCloseEnabledList);
    } else {
      completeOnSubmit(payload);
    }
  }

  const onCancel = () => {
    Modal.confirm({
      title: 'Are you sure you want to cancel changes?',
      content: 'If you cancel all changes will be lost.',
      onOk: () => populateFields(2),
      cancelText: 'Close',
    });
  }

  const onCloseDeck = (form: string, itemGame: iItemGameList, gameName: string) => {
    Modal.confirm({
      title: 'The deck will be closed immediately',
      content: 'The deck will be closed immediately, if the "Auto Create" is enabled a NEW deck will be available to play. Continue?',
      onOk: () => closeDeck(form, itemGame, gameName),
      cancelText: 'Close',
    });
  }

  const closeDeck = async (form: string, itemGame: iItemGameList, gameName: string) => {
    await closePulltabDeck({ locationId: location.id, form }, itemGame, gameName)
    await props.onSave()
  }

  const getFlare = async (id: number, form: string) => {
    loading.addLoading()
    const flare = await getPulltabGameFlare({ id })
    let values: any = []
    Object.entries(flare).forEach(entry => {
      if (entry[0]) {
        values.push({ value: numberToCurrency(entry[0]).toString(), amount: entry[1] })
      }
    });
    loading.removeLoading()
    if (values && values.length > 0) flareModal(values, form)

  }

  const flareModal = (flare: { value: string, amount: string }[], form: string) => {
    const sortedFlare = flare.sort((a, b) => transformToNumberAndCompare(b.value, a.value))
    Modal.info({
      title: `Flare ${form}`,
      okText: 'Close',
      centered: true,
      content: (
        <div className="decks-list__modal">
          <div className="decks-list__modal__row">
            <p><strong>Value</strong></p>
            <p><strong>Ticket Quantity</strong></p>
          </div>
          {sortedFlare && sortedFlare.length > 1 && sortedFlare.map((item) => (
            <div className="decks-list__modal__row">
              <p>{item.value}</p>
              <p>{item.amount}</p>
            </div>
          ))}
        </div>

      ),
    });
  }

  const checkCol = (id: string, field: string) => {
    const checkBox: any | null = document.getElementById(`check-${field}_${id}`)
    if (!checkBox) return
    const elements = document.querySelectorAll(`[data-${field}-id="${id}"]`)
    if (elements) {
      elements.forEach((element: any) => {
        if(!element.disabled) element.checked = checkBox.checked
      })
    }
    setRefresh( state => state + 1)
    checkBody()
  }


  return (
    <div>
      <div className="pulltab-decks__title">
        {(location && location.name) ? location.name : ""}
      </div>
      {location && location?.id ? (
        <>
          <ActionArea style={{ paddingBottom: 24 }}>
            <div className="pulltab-decks__controls">
              <div className="pulltab-decks__controls__row">
                <div className="pulltab-decks__controls__row__checks">
                  <label htmlFor="end_of_business_day">
                    <input disabled={!canEdit} id="end_of_business_day" type="checkbox" onClick={() => {
                      showNoPlayWarning()
                      checkBody()
                    }} />
                    Schedule to Close All Played Decks at the End of the Current Business Day {" \'" + location.currentDate + "\'"}
                  </label>
                </div>
                <div className="pulltab-decks__controls__row__checks">
                  <label htmlFor="end_of_business_month">
                    <input disabled={!canEdit} id="end_of_business_month" type="checkbox" onClick={() => {
                      showNoPlayWarning()
                      checkBody()
                    }} />
                    Close All Played Decks at the End of Every Month
                  </label>
                </div>
              </div>
              <Divider />
              <div className="pulltab-decks__controls__row">
                <div className="pulltab-decks__controls__row__item">
                  <p>Auto Create</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleControls('create', true)} className="pulltab-decks__buttons">
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleControls('create', false)} className="pulltab-decks__buttons">
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>Auto Close</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleControls('close', true)} className="pulltab-decks__buttons">
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleControls('close', false)} className="pulltab-decks__buttons">
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>Available</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleControls('avaliable', true)} className="pulltab-decks__buttons">
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleControls('avaliable', false)} className="pulltab-decks__buttons">
                      <p>None</p>
                    </button>
                  </div>
                </div>
              </div>
              <Divider />
              <div className="pulltab-decks__controls__row">
                <div className="pulltab-decks__controls__row__item">
                  <p>Wager:</p>
                </div>
              </div>
              <div className="pulltab-decks__controls__row">
                <div className="pulltab-decks__controls__row__item">
                  <p>$0.25</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('25', true)} className="pulltab-decks__buttons" >
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('25', false)} className="pulltab-decks__buttons" >
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>$0.50</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('50', true)} className="pulltab-decks__buttons" >
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('50', false)} className="pulltab-decks__buttons" >
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>$1.00</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('100', true)} className="pulltab-decks__buttons" >
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('100', false)} className="pulltab-decks__buttons" >
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>$2.00</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('200', true)} className="pulltab-decks__buttons">
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('200', false)} className="pulltab-decks__buttons" >
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>$3.00</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('300', true)} className="pulltab-decks__buttons" >
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('300', false)} className="pulltab-decks__buttons" >
                      <p>None</p>
                    </button>
                  </div>
                </div>
                <div className="pulltab-decks__controls__row__item">
                  <p>$5.00</p>
                  <div className="pulltab-decks__controls__row__item__buttons">
                    <button disabled={!canEdit} onClick={() => handleWager('500', true)} className="pulltab-decks__buttons">
                      <p>All</p>
                    </button>
                    <button disabled={!canEdit} onClick={() => handleWager('500', false)} className="pulltab-decks__buttons">
                      <p>None</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ActionArea>
          <div className="pulltab-decks__lists">
            {listGames.map((game, index) => {
              const { image } = game;

              return (
                <div key={game.id} className="pulltab-decks__lists__list">
                  <div className="pulltab-decks__lists__list__title">
                    <img src={serverUrl + '/' + image} />
                    <h2 style={{color: game.gameAvailable?"#034382": "red"}}>{game.title}</h2>
                    <h5> {!game.gameAvailable?"   * Title will not show in lobby of player terminal "
                        .concat(game.gameAvailableStart?"before " + game.gameAvailableStart:"")
                        .concat(game.gameAvailableEnd && game.gameAvailableStart?" or " :"")
                        .concat(game.gameAvailableEnd?"after " + game.gameAvailableEnd:"")
                        .concat(".  Hover mouse over wager to see availability dates of individual games."):""}</h5>
                  </div>
                  <div className="pulltab-decks__lists__table">
                    <table key={game.id + game.title}>
                      <tr>
                        <th>Wager</th>
                        <th>
                          <div className="pulltab-decks__lists__table__header--input">
                            <input
                              id={`check-avaliable_${game.id}`}
                              data-avaliable="true"
                              onClick={() => checkCol(game.id, 'avaliable')}
                              type="checkbox"
                              disabled={!canEdit}
                            />
                            Available
                          </div>
                        </th>
                        <th>
                          <div className="pulltab-decks__lists__table__header--input">
                            <input
                              id={`check-create_${game.id}`}
                              data-create="true"
                              onClick={() => checkCol(game.id, 'create')}
                              type="checkbox"
                              disabled={!canEdit}
                            /> 
                            Auto Create
                          </div>
                        </th>
                        <th >
                          <div className="pulltab-decks__lists__table__header--input">
                            <input
                              id={`check-close_${game.id}`}
                              data-close="true"
                              onClick={() => checkCol(game.id, 'close')}
                              type="checkbox"
                              disabled={!canEdit}
                            />
                            Auto Close
                          </div>
                        </th>
                        <th>Form</th>
                        <th>Tickets</th>
                        <th>Flare</th>
                        <th>Variant</th>
                        <th>Serial</th>
                        <th>Remaining</th>
                        <th>Close</th>
                      </tr>
                      {game.listItemsGame.map((itemGame, i) => {
                        let hasMoreVariants = 0
                        let variants = []
                        let numberOfVariants = 0
                        while (hasMoreVariants < 1) {
                          numberOfVariants++
                          if(!game.listItemsGame[i+numberOfVariants]) {
                            hasMoreVariants++
                          }
                          if(game.listItemsGame[i-1] && (onlyNumbers(game.listItemsGame[i-1].form) === onlyNumbers(itemGame.form))) {
                            hasMoreVariants++
                          }
                          if(game.listItemsGame[i+numberOfVariants] && hasMoreVariants < 1) {
                            if(onlyNumbers(game.listItemsGame[i+numberOfVariants].form) === onlyNumbers(itemGame.form))  {
                              variants.push({
                                ...game.listItemsGame[i+numberOfVariants]
                              })
                            }
                          }
                        }
                        return (
                         <ItemGame
                            key={i}
                            itemGame={itemGame}
                            game={game}
                            checkBody={checkBody}
                            getFlare={getFlare}
                            canEdit={canEdit}
                            onCloseDeck={onCloseDeck}
                            variants={variants}
                            gameGroup={itemGame.gameGroup}
                            gameAutoClose={itemGame.gameAutoClose}
                            gameAutoCreate={itemGame.gameAutoCreate}
                            gameGroups={gameGroups}
                         />
                        )
                      })}
                    </table>
                  </div>
                </div>
              )
            })}
          </div>
          <button
            id="floating-button-cancel"
            className="floating-button"
            onClick={() => onCancel()}
            style={{ transform: floatingButtonnStyle.translateOutView }}
          >
            <CloseOutlined style={{ color: '#FFF', fontSize: 20 }} />
            <div className="floating-button__text">
              Cancel
            </div>
          </button>
          {canEdit && (
            <button
              id="floating-button-confirm"
              className="floating-button"
              onClick={() => onSubmit()}
              style={{ display: floatingButtonnStyle.none }}
            >
              <CheckOutlined style={{ color: '#FFF', fontSize: 20 }} />
              <div className="floating-button__text">
                Save
              </div>
            </button>
          )}

        </>
      ) : null}

    </div>
  )
}

export default RawHtml
